import { createTheme, responsiveFontSizes } from "@mui/material";
import { red } from "@mui/material/colors";

const shared = {
  palette: {
    primary: {
      main: '#00b4d2',
      contrastText: '#2F2D55'
    },
    secondary: {
      main: '#2F2D55',
      contrastText: "#ffffff"
    },
    error: {
      main: red.A400,
    },
    white: {
      main: '#FFFFFF',
      contrastText: '#274B5B'
    },
    typography: {
      main: "#3C3C4B",
      contrastText: "#FFFFFF"
    },
    danger: {
      main: '#E75B5B',
      contrastText: '#FFFFFF'
    },
    active: {
      main: '#00B4D220',
      contrastText: '#00B4D2'
    }
  },
  typography: {
    htmlFontSize: 20,
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      'sans-serif'
    ].join(','),
    h1: {
      fontSize: '80px',
      fontWeight: '400',
      color: '#3C3C4B',
      lineHeight: '1.2'
    }
  }
}

let theme = createTheme({
  ...shared
});

theme = responsiveFontSizes(theme);

export { theme }